// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__1g2pp","path":"style_path__3IHsE","arrow":"style_arrow__19j-l"};